
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/icons.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-weet-icons-demo-example","docs-weet-icons-demo-custom-icon","docs-weet-icons-demo-extra","docs-weet-icons-demo-provider"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/icons.md?type=demo')
};